import { api } from "./api";

/** Connector settings are instance-wide and admin-only to change. */
export const getIntegrationsConfig = () => api.get("/api/integrations/config");
export const saveIntegrationsConfig = (payload) =>
  api.put("/api/integrations/config", payload);

export const getIntegrationsStatus = (unit) =>
  api.get("/api/integrations/status", { params: { unit } });

export const testEbmr = (unit) =>
  api.post("/api/integrations/ebmr/test", undefined, { params: { unit } });
export const syncEbmr = (unit) =>
  api.post("/api/integrations/ebmr/sync", undefined, { params: { unit } });
export const getEbmrLog = (unit) =>
  api.get("/api/integrations/ebmr/log", { params: { unit } });

export const getSapQueue = (unit) =>
  api.get("/api/integrations/sap/queue", { params: { unit } });
export const fetchSapOrders = (unit) =>
  api.post("/api/integrations/sap/fetch", undefined, { params: { unit } });
/** Accepting a staged SAP order adds it to the order book. */
export const acceptSapOrder = (unit, orderId) =>
  api.post(`/api/integrations/sap/queue/${encodeURIComponent(orderId)}/accept`,
    undefined, { params: { unit } });
export const rejectSapOrder = (unit, orderId) =>
  api.post(`/api/integrations/sap/queue/${encodeURIComponent(orderId)}/reject`,
    undefined, { params: { unit } });
export const confirmSap = (unit) =>
  api.post("/api/integrations/sap/confirm", undefined, { params: { unit } });

// The Report Center's BI section rides in the same config document —
// `bi: {provider: "metabase"|"powerbi"|null, embeds: [{title, url}]}` —
// read with getIntegrationsConfig, written (admin-only, like the rest of
// the connector settings) with saveIntegrationsConfig.
